ixModuleRouting("impactx.userdialog", {
    "/personaldata/:id": {
        template: "<ixa-personal-data></ixa-personal-data>",
        templateUrl: "modules/userdialog/templates/personaldata.html",
        controller: "UserCtrl",
        controllerAs: "userCtrl",
        process: "EditUser",
        workspace: "admin",
    },
    "/usersettings/:id": {
        template: "<ixa-user-settings></ixa-user-settings>",
        templateUrl: "modules/userdialog/templates/usersettings.html",
        controller: "UserSettingsCtrl",
        process: "EditUser",
        workspace: "admin",
    },
    "/usermessages/:id": {
        template: "<ixa-user-messages></ixa-user-messages>",
        templateUrl: "modules/userdialog/templates/usermessages.html",
        controller: "UserMessagesCtrl",
        controllerAs: "userMessagesCtrl",
        process: "EditUser",
    },
    "/userauthorizations/:id": {
        template: "<ixa-user-authorization></ixa-user-authorization>",
        templateUrl: "modules/userdialog/templates/userauthorization.html",
        controller: "UserAuthorizationCtrl",
        process: "EditUser",
        workspace: "admin",
    },
    "/userdelegation/:id": {
        template: "<ixa-delegation-user-dialog></ixa-delegation-user-dialog>",
        templateUrl: "modules/userdialog/templates/userdelegation.html",
        controller: "DelegationDialogUserCtrl",
        controllerAs: "delegationDialogUserCtrl",
        process: "EditUser",
    },
    "/usercontrol/:id": {
        template: "<ixa-user-control></ixa-user-control>",
        templateUrl: "modules/userdialog/templates/usercontrol.html",
        controller: "ControlDialogUserCtrl",
        controllerAs: "controlDialogUserCtrl",
        process: "EditUser",
    },
});
